import { nullable, struct } from 'io-ts/Decoder';

import { Certainty } from '../../Certainty';

import { Direction } from './Direction';

export const Parameter = struct({
	value: nullable(Direction),
	certainty: Certainty,
});
